function getStatusMessage(printStatus) {
    switch (printStatus) {
        case 82:
            return "打印机碳带错误，请重新安装碳带后按[取消]按键，再重新打印!";
        case 83:
            return "打印机标签错误，请重新安装标签后按[取消]按键，再重新打印!";
        case 88:
            return "打印机已经暂停，请按[暂停]按键，再重新打印!";
        case 89:
            return "标签纸用完了，请安装新标签!";
        case 90:
            return "RFID标签读写错误，请按[取消]按键，再重新打印!";
        case 91:
        case 92:
            return "RFID标签校准错误，请按[取消]按键，再重新打印!";
        case -1007:
            return "打印机端口异常，请检查打印机是否正常连接且已开机.";
        default:
            return "打印机状态异常，错误代码: " + printStatus;
    }
}

import printObj from "./label_objects.js";

function getLabelObjectListByNormal(data) {
    let objList = []
    
    // 只打印二维码
    let barcodeObj = printObj.getBarcodeObj()
    barcodeObj.Xposition = 30 // 你可以根据实际标签纸宽度调整
    barcodeObj.Yposition = 5 // 调整到文本下方，避免重合
    barcodeObj.objectdata = data.var4
    barcodeObj.barcodekind = 'QR Code(2D)'
    barcodeObj.barcodescale = 4 // 1倍缩放，确保精确尺寸
    barcodeObj.barcodeheight = 70 // 10mm = 118点（300dpi）
    // barcodeObj.barcodealign = 1
    barcodeObj.textposition = 2
    // 不设置width/height

    objList.push(barcodeObj)
    return objList
}




function getLabelObjectListByImage(data) {
    let objList = []
    let barImageObj = printObj.getImageObj()
    
    // 设置图片位置
    barImageObj.Xposition = 50   // 左边距25mm，往右边移动避免被裁剪
    barImageObj.Yposition = 20   // 上边距10mm
    
    // 使用固定尺寸模式
    barImageObj.imagefixedsize = true
    barImageObj.imagefixedwidth = 5   // 固定宽度6mm，再减小一点
    barImageObj.imagefixedheight = 5  // 固定高度6mm，再减小一点
    
    // 旋转90度
    barImageObj.direction = 3

    // 保持长宽比
    barImageObj.aspectRatio = true
    
    // 缩放率设置为0.25（25%），再缩小一点
    barImageObj.hscale = 0.2
    barImageObj.vscale = 0.2
    
    // 确保图片数据是有效的Base64格式
    if (data && typeof data === 'string') {
        // 如果数据包含data:image前缀，需要去掉
        if (data.startsWith('data:image')) {
            const base64Data = data.split(',')[1]
            barImageObj.imagedata = base64Data
        } else {
            // 直接使用数据，但确保没有多余的空格或换行符
            barImageObj.imagedata = data.trim()
        }
    } else {
        console.error('图片数据格式错误:', data)
        return objList
    }
    
    console.log(barImageObj)
    objList.push(barImageObj)
    return objList
}


// 新增：文字打印方法
function getLabelObjectListByText() {
    let objList = []

    // 第二个文本：订单号信息
    let textObj2 = printObj.getTextObj()
    textObj2.Xposition = 50
    textObj2.Yposition = 10
    textObj2.objectdata = "香味研究所"
    textObj2.fontsize = 8  // 调小字体大小，从默认的10减小到6
    // 旋转90度
    textObj2.direction = 3

    // objList.push(textObj)
    objList.push(textObj2)
    // objList.push(barcodeObj)
    return objList
}

// 新增：二维码打印方法，将报告图URL转为二维码

/** 作业列表 URL 是否带 t=1 / t=2（比订单列表略长，需微调 QR） */
function jobReportQrNeedsCompact(url) {
    return /[?&]t=/.test(String(url || ""));
}

/** 仅带 t 参数时略缩 scale（4.6→4.4），位置/高度与订单列表相同 */
function resolveJobQrBarcodeScale(url) {
    const len = String(url || "").length;
    if (len <= 50) return 4.4;
    return 4.2;
}

function applyReportQrCodeObject(qrCode8, qrUrl, preset) {
    qrCode8.Xposition = preset.x;
    qrCode8.Yposition = preset.y;
    qrCode8.objectdata = qrUrl;
    qrCode8.barcodekind = "QR Code(2D)";
    qrCode8.barcodescale =
        typeof preset.scale === "function"
            ? preset.scale(qrUrl)
            : preset.scale;
    qrCode8.barcodeheight = preset.height;
    qrCode8.barcodealign = 1;
    qrCode8.textposition = 2;
}

/** 鉴别/寄售订单列表：保持历史打印参数不变 */
const ORDER_LIST_QR_PRESET = {
    x: 17,
    y: 3.2,
    scale: 4.6,
    height: 10,
};

/** 作业列表 · 闲置/安心购（URL 带 t=）：位置与订单列表一致，仅略降 scale 防右侧裁切 */
const INSPECTION_JOB_QR_PRESET_COMPACT = {
    x: 17,
    y: 3.2,
    scale: resolveJobQrBarcodeScale,
    height: 10,
};

function buildLabelObjectListByQRCodev2(data, qrPreset) {
    let objList = []

    // 
    let textObj = printObj.getTextObj()
    textObj.Xposition = 50.5
    textObj.Yposition = 1.4
    textObj.objectdata = data.var1
    textObj.fontsize = 8  // 适配16mm高度
    textObj.labelrowgap = 1  // 添加行距
    textObj.labelcolumngap = 1  // 添加列距
    // 旋转90度
    textObj.direction = 3

    //===========================================================

    let barImageObj = printObj.getImageObj()
    // 设置图片位置
    barImageObj.Xposition = 46   // 适配60mm宽度
    barImageObj.Yposition = 6.7// 适配16mm高度
    // 使用固定尺寸模式
    barImageObj.imagefixedsize = true
    barImageObj.imagefixedwidth = 3.8   // 适配小标签
    barImageObj.imagefixedheight = 3.8  // 适配小标签
    // 旋转90度
    barImageObj.direction = 3
    // 保持长宽比
    barImageObj.aspectRatio = true
    // 缩放率设置为0.25（25%），再缩小一点
    barImageObj.hscale = 0.16
    barImageObj.vscale = 0.16
    // 确保图片数据是有效的Base64格式
    if (data.var2 && typeof data.var2 === 'string') {
        // 如果数据包含data:image前缀，需要去掉
        if (data.var2.startsWith('data:image')) {
            const base64Data = data.var2.split(',')[1]
            barImageObj.imagedata = base64Data
        } else {
            // 直接使用数据，但确保没有多余的空格或换行符
            barImageObj.imagedata = data.var2.trim()
        }
    } else {
        console.error('图片数据格式错误:', data)
        return objList
    }

    //===========================================================

    // 竖排显示"撕毁无效"
    let textObj2 = printObj.getTextObj()
    textObj2.Xposition = 41
    textObj2.Yposition = 7.2
    textObj2.objectdata = data.var3
    textObj2.fontsize = 8
    textObj2.labelrowgap = 1
    textObj2.labelcolumngap = 1  // 添加列距
    textObj2.direction = 3

    let textObj3 = printObj.getTextObj()
    textObj3.Xposition = 38
    textObj3.Yposition = 7.2
    textObj3.objectdata = data.var4
    textObj3.fontsize = 8
    textObj3.labelrowgap = 1
    textObj3.direction = 3
    textObj3.labelcolumngap = 1

    let textObj4 = printObj.getTextObj()
    textObj4.Xposition = 35
    textObj4.Yposition = 7.2
    textObj4.objectdata = data.var5
    textObj4.fontsize = 8
    textObj4.labelrowgap = 1  // 添加行距
    textObj4.labelcolumngap = 1  // 添加列距
    textObj4.direction = 3

    let textObj5 = printObj.getTextObj()
    textObj5.Xposition = 32
    textObj5.Yposition = 7.2
    textObj5.objectdata = data.var6
    textObj5.fontsize = 8
    textObj5.labelrowgap = 1  // 添加行距
    textObj5.labelcolumngap = 1  // 添加列距
    textObj5.direction = 3


    let textObj7 = printObj.getTextObj()
    textObj7.Xposition = 26
    textObj7.Yposition = 6.6
    textObj7.objectdata = data.var7
    textObj7.fontsize = 5  // 适配16mm高度
    textObj7.labelrowgap = 1  // 添加行距
    textObj7.labelcolumngap = 1  // 添加列距
    // 旋转90度
    textObj7.direction = 3

    const qrUrl = data.var8 || "";
    let qrCode8 = printObj.getBarcodeObj()
    applyReportQrCodeObject(qrCode8, qrUrl, qrPreset)

    objList.push(textObj)
    objList.push(barImageObj)
    objList.push(textObj2)
    objList.push(textObj3)
    objList.push(textObj4)
    objList.push(textObj5)
    objList.push(textObj7)
    objList.push(qrCode8)

    return objList
}

/** 鉴别订单 / 寄售订单列表「鉴别报告打印」 */
function getLabelObjectListByQRCodev2(data) {
    return buildLabelObjectListByQRCodev2(data, ORDER_LIST_QR_PRESET)
}

/** 鉴别作业列表「鉴别报告打印」：无 t 与订单列表同参；有 t 仅微调 */
function getLabelObjectListByQRCodev2Job(data) {
    const qrUrl = data.var8 || "";
    const preset = jobReportQrNeedsCompact(qrUrl)
        ? INSPECTION_JOB_QR_PRESET_COMPACT
        : ORDER_LIST_QR_PRESET;
    return buildLabelObjectListByQRCodev2(data, preset);
}



function getImageObj() {
    return {
        objectName: 'image-01',// 图片对象以"image"开头，如"image-01"，"image-02"...
        imagedata: null,// 图片数据，base64格式的字符串
        Xposition: 30,//在标签上的位置，单位是mm
        Yposition: 5,//在标签上的位置，单位是mm
        imagewidth: 10,//图片宽度，单位是mm
        imageheight: 10//图片高度，单位是mm
    }
}




function getLabelObjectListByRFID(data) {
    let objList = []
    let textObj1 = printObj.getTextObj()
    textObj1.Xposition = 5
    textObj1.Yposition = 10
    textObj1.objectdata = data.var2

    let textObj2 = printObj.getTextObj()
    textObj2.Xposition = 5
    textObj2.Yposition = 20
    textObj2.objectdata = data.var3

    let barcodeObj = printObj.getBarcodeObj()
    barcodeObj.barcodekind = 'QR Code(2D)'
    barcodeObj.Xposition = 50
    barcodeObj.Yposition = 10
    barcodeObj.objectdata = data.var4

    let rfidObj = printObj.getRfidObj()
    rfidObj.objectdata = data.var4
    rfidObj.RFIDDatablock = 0
    rfidObj.RFIDDatatype = 1
    rfidObj.RFIDerrortimes = 1
    rfidObj.RFIDEncodertype = 0

    objList.push(textObj1)
    objList.push(textObj2)
    objList.push(barcodeObj)
    objList.push(rfidObj)
    return objList
}

function getLabelObjectListByLsf(data) {
    let dataArr = []
    //如果使用lsf模板打印RFID的话，在模板上的RFID对象的子字符串共享名称设置后，同样利用varname的形式填充RFID数据即可
    let lsfObj = {
        lsfFileVarList: [{
            lsfFileVar:
                {
                    varname: 'assetName', // lsf模板中设定的子字符串共享名称
                    varvalue: data.var2 // 需要变更的打印的参数的值
                }
        },
            {
                lsfFileVar:
                    {
                        varname: 'useDepartmentName', // lsf模板中设定的子字符串共享名称
                        varvalue: data.var3 // 需要变更的打印的参数的值
                    }
            },
            {
                lsfFileVar:
                    {
                        varname: 'assetNumbering', // lsf模板中设定的子字符串共享名称
                        varvalue: data.var4 // 需要变更的打印的参数的值
                    }
            }]
    }
    dataArr.push(lsfObj)
    return dataArr
}


// 新增：二维码打印方法，将报告图URL转为二维码
function getLabelObjectListByQRCode(data) {
    let objList = []
    
    // 第一个文本：品牌和类型信息
    let textObj = printObj.getTextObj()
    textObj.Xposition = 5
    textObj.Yposition = 10
    textObj.objectdata = data.var2

    // 第二个文本：订单号信息
    let textObj2 = printObj.getTextObj()
    textObj2.Xposition = 5
    textObj2.Yposition = 25
    textObj2.objectdata = data.var3

    // 二维码：使用报告图URL
    let barcodeObj = printObj.getBarcodeObj()
    barcodeObj.Xposition = 40 // 你可以根据实际标签纸宽度调整
    barcodeObj.Yposition = 40.5 // 调整到文本下方，避免重合
    barcodeObj.objectdata = data.var4
    barcodeObj.barcodekind = 'QR Code(2D)'
    barcodeObj.barcodescale = 60 // 1倍缩放，确保精确尺寸
    barcodeObj.barcodeheight = 1000 // 10mm = 118点（300dpi）
    // barcodeObj.barcodewidth = 118 // 如果有此属性，建议加上
    barcodeObj.barcodealign = 1
    barcodeObj.textposition = 2

    objList.push(textObj)
    objList.push(textObj2)
    objList.push(barcodeObj)
    return objList
}

export default {
    getStatusMessage, // 获取打印机状态返回的参数Message
    getLabelObjectListByNormal,// 获取普通标签打印示例内容
    getLabelObjectListByRFID,// 获取RFID标签打印示例内容
    getLabelObjectListByLsf,// 获取LSF模板文教标签打印示例内容
    getLabelObjectListByQRCode,// 获取二维码标签打印示例内容
    getLabelObjectListByImage// 获取图片对象
    ,getLabelObjectListByText
    ,getLabelObjectListByQRCodev2
    ,getLabelObjectListByQRCodev2Job
}


// WEBPACK FOOTER //
// ./src/components/json_demo.js